import React from 'react';
import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
  InputAdornment,
  Typography,
} from '@mui/material';
import styled from 'styled-components';

type TextFieldProps = MuiTextFieldProps & {
  helper?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
};

const StyledTextField = styled(MuiTextField)<TextFieldProps>`
  .MuiOutlinedInput-root {
    border-radius: 12px;
    background-color: ${({ theme }) => theme.palette.background.paper};
    transition: all 0.2s ease;

    &:hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${({ theme }) => theme.palette.primary.main};
      }
    }

    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 2px;
      }
    }
  }

  .MuiInputLabel-root {
    &.Mui-focused {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  .MuiOutlinedInput-input {
    padding: ${({ size }) =>
      size === 'small' ? '10px 14px' : '14px 16px'};
  }
`;

const Helper = styled(Typography)<{ error?: boolean }>`
  margin-top: 4px;
  color: ${({ theme, error }) =>
    error ? theme.palette.error.main : theme.palette.text.secondary};
  font-size: 0.75rem;
`;

const TextField: React.FC<TextFieldProps> = ({
  label,
  helper,
  error = false,
  startIcon,
  endIcon,
  fullWidth = true,
  ...props
}) => {
  return (
    <div>
      <StyledTextField
        variant="outlined"
        error={error}
        fullWidth={fullWidth}
        InputProps={{
          startAdornment: startIcon && (
            <InputAdornment position="start">{startIcon}</InputAdornment>
          ),
          endAdornment: endIcon && (
            <InputAdornment position="end">{endIcon}</InputAdornment>
          ),
        }}
        {...props}
      />
      {helper && <Helper error={error}>{helper}</Helper>}
    </div>
  );
};

export default TextField; 